import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {Typography} from 'antd'
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {ClockCircleOutlined, SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import HttpError from '../../component/base/HttpError'
import samplePicture from '../../asset/image/43724.jpg'
import {getAllArtistContractTemplates} from "../../api/artistContractTemplates";
import {getEditUrl} from "../../component/Utils";
import {URL_HOME, URL_LOGIN, URL_TEMPLATES_ID} from "../../const";
import {IN_PRODUCT} from "../../config/product";
import {is_admin_user, is_premium_plan} from "../../app/role";
import PlanExpireModal from "../../component/base/PlanExpireModal";
import {userLogout} from "../../action/user";

const {Title} = Typography

@connect(
    (state) => ({
        userId: state.user.info.id,
        email: state.user.info.email,
        role: state.user.info.role,
        plan: state.user.plan
    }),
    {userLogout}
)
class Template extends React.Component {
    constructor(props) {
        super(props)
        this.state = {planModalVisible: false}
        this.columnsInfo = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id',
                width: 45
            },
            {
                title: 'Document Title',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: 'Date Added',
                dataIndex: 'create',
                key: 'create',
            },
        ]
        this.sortOptions = [
            {
                text: 'Document Title (a-z)',
                value: 'title',
                icon: <SortDescendingOutlined/>
            },
            {
                text: 'Document Title (z-a)',
                value: '-title',
                icon: <SortAscendingOutlined/>
            },
            {
                text: 'Date Added (recent)',
                value: '-create',
                icon: <ClockCircleOutlined/>
            },
            {
                text: 'Date Added (old)',
                value: 'create',
                icon: <ClockCircleOutlined/>
            },
        ]
        this.filterOptions = null
        this.hb_script = document.createElement('script');
    }

    componentDidMount() {
        if (IN_PRODUCT) {
            this.hb_script.src = "//js.hs-scripts.com/7839862.js";
            this.hb_script.async = true;
            document.body.appendChild(this.hb_script);
        }

        if (!is_premium_plan(this.props)) {
            this.setState({planModalVisible: true})
        }
    }

    componentWillUnmount() {
        if (IN_PRODUCT) {
            document.body.removeChild(this.hb_script)
        }
    }

    getInitialData = (resolve, reject, pageId, pageSize, sort, filters, search, cancelToken) => {
        let params = {}
        if (sort) {
            params['ordering'] = sort.value || sort
        }
        if (search) {
            params['search'] = search
        }
        getAllArtistContractTemplates(params, pageId, pageSize, cancelToken).then((response) => {
            for (const contract of response.data.results) {
                let name = ''
                contract.name = name
                if (is_admin_user(this.props)) {
                    contract.title = contract.title + ' ' + contract.name
                }
                contract.url = ''
                contract.static_url = samplePicture;
            }
            const apiData = {
                data: response.data
            }
            resolve(apiData);
        }).catch((error) => {
            HttpError(error)
        })
    }

    capitalizeName(name) {
        return name.replace(/\b(\w)/g, (s) => s.toUpperCase())
    }

    reqData = (pageId, pageSize, sort, filters, search) => {
        return new Promise((resolve, reject) => {
            this.getInitialData(resolve, reject, pageId, pageSize, sort, filters, search);
        });
    }

    deleteData = (id) => {
        // call api to delete by id
        return new Promise((resolve, reject) => {
            resolve();
        });
    }

    getOpenUrl = (record) => {
        return getEditUrl(URL_TEMPLATES_ID, record.id)
    }

    logout = () => {
        this.props.userLogout()
        this.props.history.replace({pathname: URL_LOGIN})
    }

    onSubscriptionChanged = (isSubscribed = false, updatedTime=null) => {
        this.setState({
            planModalVisible: !isSubscribed
        })
    }

    render() {
        return (
            <div>
                <PlanExpireModal open={this.state.planModalVisible} logout={this.logout} isUpgrade={true} onClose={()=>{
                    this.setState({planModalVisible: false})
                    window.location.href = URL_HOME
                }} onSubscriptionChanged={this.onSubscriptionChanged}/>
                <GalleryTablePanel
                    name={'Template'}
                    requestData={this.reqData}
                    columns={this.columnsInfo}
                    disableGalleryRatioOption={true}
                    tableWidth={800}
                    actionWidth={100}
                    getOpenUrl={this.getOpenUrl}
                    sortOptions={this.sortOptions}
                    defaultSortOption={this.sortOptions[3]}
                    disableImport={true}
                    disableAdd={true}
                    viewOptions={['table']}/>
            </div>
        )
    }

}

export default withRouter(Template)